import baseStyles from '@ts-core/styles/baseStyles';

const styles = (theme) => ({
  ...baseStyles(theme),
  assignmentTitle: {
    fontSize: 20,
    fontWeight: 500,
    marginLeft: 8,
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default styles;
